import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var TwitterSVG = function TwitterSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M29.91 7a10.14 10.14 0 01-3.44 1 6.06 6.06 0 002.62-3.44A11 11 0 0125.29 6 5.68 5.68 0 0021 4a6.15 6.15 0 00-6 6.3v-.15a6.44 6.44 0 00.17 1.31A15.39 15.39 0 014 5.41a5.81 5.81 0 00-.79 2.89 6 6 0 002.4 4.83 4.84 4.84 0 01-2.48-.7v.26a5.92 5.92 0 004.58 5.86 9 9 0 01-1.47.18 4.52 4.52 0 01-1-.09 5.85 5.85 0 005.28 4.21 10.77 10.77 0 01-7.1 2.56A7.12 7.12 0 012 25.32 16.51 16.51 0 0010.83 28C21.3 28 27 18.82 27 10.86v-.64A16.34 16.34 0 0029.91 7z"
  }));
};
TwitterSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(TwitterSVG);